import { inject, Injectable } from '@angular/core';
import { AppStateCacheService } from '@lentau/core/app-state-cache/shared/app-state-cache.service';
import { withCacheErrorHandling } from '@lentau/core/app-state-cache/shared/cache-error.decorator';
import { AppCacheKeys } from '@lentau/core/app-state-cache/shared/cache.constants';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';
import { MissionAddressMode } from './types';
import { MissionAddressCacheMapper } from './mission-address-cache-mapper';

@Injectable({
  providedIn: 'root',
})
export class MissionAddressModeCacheService {
  private appStateCacheService: AppStateCacheService = inject(AppStateCacheService);
  private browserApiSupportService: BrowserApiSupportService = inject(BrowserApiSupportService);

  public isExistCache: boolean = false;

  @withCacheErrorHandling(AppCacheKeys.MissionAddressMode)
  public getInitValue(): MissionAddressMode {
    if (this.browserApiSupportService.isSearchBot()) return null;

    const missionAddressMode: string = this.appStateCacheService.get(AppCacheKeys.MissionAddressMode);

    // Если кеш пустой
    if (!missionAddressMode) return null;

    this.isExistCache = true;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parsedData: Record<string, any> = JSON.parse(missionAddressMode);
    return MissionAddressCacheMapper.composeFromCache(parsedData);
  }

  public updateCache(deliveryAddress: MissionAddressMode): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const decomposedData: Record<string, any> = MissionAddressCacheMapper.decomposeForCache(deliveryAddress);
    this.appStateCacheService.set(AppCacheKeys.MissionAddressMode, JSON.stringify(decomposedData));
  }

  public clearCache(): void {
    this.appStateCacheService.delete(AppCacheKeys.MissionAddressMode);
  }
}
